import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { getAxiosResponse, postAxiosResponse, putOrPostAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { dateConvertToTimeStamp, transformBlankToNull, isValidHttpUrl, getLoggedInUserRole } from '../../../services/Util';
import Constants from "../../../Constants";
import DataTable, { createTheme } from "react-data-table-component";
import jQuery from "jquery";
import MarketoRestCredential from "./MarketoRestCredential";
import BackToSetting from "../BackToSetting"
import UserPermissionsSetting from "./UserPermissionsSetting"
import {getSettings} from "./IntegrationSettingsUtil"
import { RotatingLines } from "react-loader-spinner";
import SuccessMessage from "../../../components/SuccessMessage";
import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import $ from "jquery";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { logError } from "../../../services/authApiRoutes/APImethods";


export default function MarketoRestIntegrationSetting() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const MarketoRestCredentialMemo = React.memo(MarketoRestCredential);
  const UserPermissionsSettingMemo = React.memo(UserPermissionsSetting);
  const roleArray = getLoggedInUserRole();
  const [departments, setDepartments] = useState([]);
  const [preference, setPreference] = useState();
  const [sharedCredentials, setSharedCredentials] = useState();
  const [systemUserCredentialsAllDepartments, setSystemUserCredentialsAllDepartments] = useState([]);
  const [systemUserCredentialData, setSystemUserCredentialData] = useState();
  const [deptPreference, setDeptPreference] = useState({});
  const [settings, setSettings] = useState([]);
  const [pendingDeptSettings, setPendingDeptSettings] = useState(false);
  const [showCustomerCred, setShowCustomerCred] = useState(true);
  const [department, setDepartment] = useState({});
  const [credentialData, setCredentialData] = useState({});
  const [authCodeMode, setAuthCodeMode] = useState(false);
  const [serverErrorMessage, setServerErrorMessage] = useState([]);
  const [isValidating, setValidating] = useState(false);
  const [successMessage, setSuccessMessage] = useState(Constants.BLANK);
  const [integrationUsers, setIntegrationUsers] = useState([]);
  const [pendingPermission, setPendingPermission] = useState(false);
  const [user, setUser] = useState();
  const [permissionStatus,setPermissionStatus]=useState(false)
  
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const theme = aaaSelected ? "dark" : "";

  useEffect(()=>{
    $(".lastdisable").trigger("focus");
  }, [])

  const showEditModel = (setting) => {
    setShowCustomerCred(false);
    setDepartment(setting.userGroup);
    getSystemUserCredential(setting.userGroup.id)
    setServerErrorMessage([]);
    setSuccessMessage(Constants.BLANK);
    document.body.classList.add("modal-open");
  };
  const hideEditModel = () => {
    setShowCustomerCred(true);
    setSuccessMessage(Constants.BLANK);
    setAuthCodeMode(false);
    setServerErrorMessage([]);
    document.body.classList.remove("modal-open");
  };

  const deptSettingsColumns = [
    {
      id: "setting.name",
      name: "Department",
      maxWidth: "350px",
      selector: (setting) => setting.userGroup,
      sortable: true,
      cell: (setting) => setting.userGroup.name
    },
    {
      id: "setting.dependencies",
      name: "Default include dependencies checkbox behavior (on/off)",
      maxWidth: "350px",
      wrap: true,
      subHeaderWrap:true,
      center: true,
      selector: (setting) => setting.MARKETOREST_DEFAULT_INCLUDE_DEPENDENCIES_CHECKBOX,
      cell: (setting) => (
        <div className="form-check m-0">
            <input className="form-check-input integration-setting" type="checkbox" name="checkbox" id={"dependencies-" +setting.userGroup.id} 
            data-group={setting.userGroup.id} data-pref="MARKETOREST_DEFAULT_INCLUDE_DEPENDENCIES_CHECKBOX" checked={setting.MARKETOREST_DEFAULT_INCLUDE_DEPENDENCIES_CHECKBOX == 'true'} 
            onChange={(e) => updatePreference(e)} />
            <label className="form-check-label" aria-label="checkbox" for={"dependencies-" +setting.userGroup.id}>&nbsp;</label>
        </div>
      )
    },
    {
      id: "setting.ancestor",
      name: "Translate tokens in ancestor projects/folders",
      maxWidth: "350px",
      selector: (setting) => setting.name,
      wrap: true,
      center: true,
      cell: (setting) => (
        <div className="form-check m-0">
            <input className="form-check-input integration-setting" type="checkbox" name="checkbox" id={"ancestor-" +setting.userGroup.id} 
            data-group={setting.userGroup.id} data-pref="MARKETOREST_RECURSIVE_TOKENS" checked={setting.MARKETOREST_RECURSIVE_TOKENS == 'true'} 
            onChange={(e) => updatePreference(e)} />
            <label className="form-check-label" aria-label="checkbox" for={"ancestor-" +setting.userGroup.id}>&nbsp;</label>
        </div>
      )
    },
    {
      id: "setting.form",
      name: "Translate form validation messages",
      maxWidth: "350px",
      selector: (setting) => setting.name,
      wrap: true,
      center: true,
      cell: (setting) => (
        <div className="form-check m-0">
          <input className="form-check-input integration-setting" type="checkbox" name="checkbox" id={"form-" +setting.userGroup.id} 
          data-group={setting.userGroup.id} data-pref="MARKETOREST_FORM_VALIDATION_MESSAGE" checked={setting.MARKETOREST_FORM_VALIDATION_MESSAGE == 'true'} 
          onChange={(e) => updatePreference(e)} />
          <label className="form-check-label" aria-label="checkbox" for={"form-" +setting.userGroup.id}>&nbsp;</label>
        </div>
      )
    },
    {
      id: "setting.velocity",
      name: "Translate Velocity Script Tokens",
      maxWidth: "350px",
      selector: (setting) => setting.name,
      wrap: true,
      center: true,
      cell: (setting) => (
        <div className="form-check m-0">
          <input className="form-check-input integration-setting" type="checkbox" name="checkbox" data-group={setting.userGroup.id} 
          data-pref="MARKETOREST_VELOCITY_TOKENS" id={"velocity-" +setting.userGroup.id} checked={setting.MARKETOREST_VELOCITY_TOKENS == 'true'} 
          onChange={(e) => updatePreference(e)} />
          <label className="form-check-label" aria-label="checkbox" for={"velocity-" +setting.userGroup.id}>&nbsp;</label>
        </div>
      )
    },
    {
      id: "setting.forms",
      name: "Translate Included Forms",
      maxWidth: "350px",
      selector: (setting) => setting.name,
      wrap: true,
      center: true,
      cell: (setting) => (
        <div className="form-check m-0">
          <input className="form-check-input integration-setting" type="checkbox" name="checkbox" data-group={setting.userGroup.id} 
          data-pref="MARKETOREST_TRANSLATE_FORMS_INSIDE_ASSET" id={"translate-forms-" +setting.userGroup.id} checked={setting.MARKETOREST_TRANSLATE_FORMS_INSIDE_ASSET == 'true'}
          onChange={(e) => updatePreference(e)} />
          <label className="form-check-label" aria-label="checkbox" for={"translate-forms-" +setting.userGroup.id}>&nbsp;</label>
        </div>
      )
    },
    {
      id: "setting.snippets",
      name: "Translate Included Snippets",
      maxWidth: "350px",
      selector: (setting) => setting.name,
      wrap: true,
      center: true,
      cell: (setting) => (
        <div className="form-check m-0">
          <input className="form-check-input integration-setting" type="checkbox" name="checkbox" data-group={setting.userGroup.id} 
          data-pref="MARKETOREST_TRANSLATE_SNIPPETS_INSIDE_ASSET" id={"translate-snippets-" +setting.userGroup.id} checked={setting.MARKETOREST_TRANSLATE_SNIPPETS_INSIDE_ASSET == 'true'}
          onChange={(e) => updatePreference(e)} />
          <label className="form-check-label" aria-label="checkbox" for={"translate-snippets-" +setting.userGroup.id}>&nbsp;</label>
        </div>
      )
    },
    {
      id: "setting.plainToken",
      name: "Translate Included Plain Text Token",
      maxWidth: "350px",
      selector: (setting) => setting.name,
      wrap: true,
      center: true,
      cell: (setting) => (
        <div className="form-check m-0">
          <input className="form-check-input integration-setting" type="checkbox" name="checkbox" data-group={setting.userGroup.id} 
          data-pref="MARKETOREST_TRANSLATE_PLAIN_TEXT_TOKEN" id={"translate-plain-" +setting.userGroup.id} checked={setting.MARKETOREST_TRANSLATE_PLAIN_TEXT_TOKEN == 'true'}
          onChange={(e) => updatePreference(e)} />
          <label className="form-check-label" aria-label="checkbox" for={"translate-plain-" +setting.userGroup.id}>&nbsp;</label>
        </div>
      )
    },
    {
      id: "setting.textToken",
      name: "Translate Included Rich Text Token",
      maxWidth: "350px",
      selector: (setting) => setting.name,
      wrap: true,
      center: true,
      cell: (setting) => (
        <div className="form-check m-0">
          <input className="form-check-input integration-setting" type="checkbox" name="checkbox" data-group={setting.userGroup.id} 
          data-pref="MARKETOREST_TRANSLATE_RICH_TEXT_TOKEN" id={"translate-rich-" +setting.userGroup.id} checked={setting.MARKETOREST_TRANSLATE_RICH_TEXT_TOKEN == 'true'}
          onChange={(e) => updatePreference(e)} />
          <label className="form-check-label" aria-label="checkbox" for={"translate-rich-" +setting.userGroup.id}>&nbsp;</label>
        </div>
      )
    },
    {
      id: "setting.credentials",
      name: "System User Credentials",
      maxWidth: "350px",
      selector: (setting) => setting.name,
      center: true,
      cell: (setting) => (
        <div className="flex-center">
          {setting.isCredentialFound 
          ? 
          <button className="inline-flex ml-10" aria-label="edit" onClick={() => showEditModel(setting)}>
            <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
              <path d="M4.65122 14.1491H0.817969V10.3143L10.5199 0.642481L10.52 0.642316C10.8375 0.324878 11.2595 0.15 11.7092 0.15C12.1589 0.15 12.5809 0.324838 12.8993 0.643233L14.3532 2.09707C14.6715 2.41546 14.8464 2.83748 14.8464 3.28717C14.8464 3.73685 14.6715 4.15887 14.3532 4.47727L4.65122 14.1491ZM11.8152 1.7272L11.7093 1.62143L11.6033 1.7271L10.1467 3.1791L10.0403 3.2852L10.1466 3.39143L11.6004 4.84435L11.7063 4.95015L11.8123 4.84452L13.2698 3.39252L13.3764 3.28638L13.27 3.18012L11.8152 1.7272ZM2.3513 12.4657V12.6157H2.5013H3.95605H4.01805L4.06195 12.572L10.5144 6.13973L10.6208 6.03367L10.5145 5.92743L9.0607 4.4736L8.9548 4.3677L8.84873 4.47343L2.3954 10.9066L2.3513 10.9506V11.0128V12.4657ZM0.817969 16.2824H15.1846V17.8157H0.817969V16.2824Z" fill="#1D4ED8" stroke="#F1F5FF" strokeWidth="0.3"/>
            </svg>
          </button>
          : 
          <button className="inline-flex" aria-label="Add" onClick={() => showEditModel(setting)}>
            <svg className="aaa-change-stroke" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
              <path d="M8.64062 1V15.72" stroke="#1D4ED8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M1.28027 8.36011H16.0003" stroke="#1D4ED8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        }
        </div>
      )
    }
  ];

  useEffect(() => {
    getIntegrationusers();
    getAllDepartments();
    getAllDepartmentSystemUserCredential(Constants.MARKETOREST);
    getDepartmentPreference();
    getPreference();
    getSharedCredentials();
    getUser();
    //getCredential();    
  }, [])

  useEffect(() => {
    if (user?.permissions[Constants.MARKETOREST_ACCESS] === true) {
      getCredential();
    }
  }, [user])

  useEffect(() => {
    if (deptPreference && Object.keys(deptPreference).length > 0 && departments.length > 0) {
      let localSettings = getSettings(deptPreference, departments);
      if (pendingDeptSettings === true) {
        localSettings?.map(setting => {
        getSystemUserCredential(setting?.userGroup?.id, setting);
        })
      }
      setSettings(localSettings);
      setPendingDeptSettings(false);
    }
  }, [deptPreference, departments])

  useEffect(()=>{
    if(successMessage!==Constants.BLANK){
      setSuccessMessage(successMessage);
      setTimeout(function(){
        setSuccessMessage(Constants.BLANK);
      },5000);
    }
  },[successMessage]);

  const submitCredential = (isForSystemUser) => {
    if(!validateCredential()) {
      return;
    }
    setValidating(true);
    var isPost = true;
    var urlString;
    let localCredentialData = isForSystemUser ? systemUserCredentialData : credentialData;    
    let dataToSave;
    if (authCodeMode) {	
      urlString = APIUrls.MARKETO_DEVICE_AUTHORIZATION;	
      dataToSave = JSON.parse(JSON.stringify(localCredentialData))
      dataToSave.credentials.DEVICE_AUTH_CODE = jQuery.trim(jQuery("#marketo-rest-authcode-input").val());
    } else {
        dataToSave = {credentials:{
        CLIENT_ID : jQuery.trim(jQuery("#marketo-client-id-input").val()),
        CLIENT_SECRET : jQuery.trim(jQuery("#marketo-client-secret-input").val()),
        IDENTITY_URL : jQuery.trim(jQuery("#marketo-identity-url-input").val()),
        ENDPOINT_URL : jQuery.trim(jQuery("#marketo-endpoint-url-input").val())  	  
        }, credentialsType: "MARKETOREST"};

        if(isForSystemUser){
          dataToSave.selectedUserGroupId = department?.id;
          dataToSave.dataGroupId = department?.id;
          urlString = APIUrls.CUSTOMER_EXTERNAL_SYSTEM_USER_CREDENTIALS(Constants.MARKETOREST) + `?userGroupId=${department?.id}`;
        } else {
          urlString = APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(Constants.MARKETOREST);
        }
        dataToSave.credentials.USERNAME = jQuery.trim(jQuery("#marketo-rest-username-input").val())    	  		
        dataToSave.credentialCharArray = jQuery.trim(jQuery("#marketo-rest-password-input").val()).split('')	  			   
    }
    if(localCredentialData?.id){
      isPost = false;
      dataToSave.id = localCredentialData?.id;
    }

    putOrPostAxiosResponse(urlString, dataToSave, isPost
      ).then((res) => {
        setValidating(false);
        if (res.data?.handledMessage?.indexOf("Device Verification") > 0)  {
          setAuthCodeMode(true);
          getSystemUserCredential(dataToSave.dataGroupId)
        } else if (res.data?.handledMessage || res.data?.data?.handledMessage){
          setAuthCodeMode(false);
          setServerErrorMessage([res.data.handledMessage])
        } else {
          setServerErrorMessage([])
          setSuccessMessage("Credential successfully updated!")
          setTimeout(hideEditModel, 6000);
        }
      }).catch((err) => {
        setValidating(false);
        const errorMessage = "err - ";
        logError(errorMessage, err);       })

  }

  const validateCredential = () => {
    setServerErrorMessage([]);
    var errorMsgs = [];

    if (authCodeMode) {
      if (jQuery.trim(jQuery("#marketo-rest-authcode-input").val()) == "") {
        errorMsgs.push("Please enter auth code for Marketo Rest.")
      }
    } else {
      if (jQuery.trim(jQuery("#marketo-client-id-input").val()) == ""){
        errorMsgs.push("Please enter client id for Marketo Rest.")
      } 
      if (jQuery.trim(jQuery("#marketo-client-secret-input").val()) == ""){
        errorMsgs.push("Please enter client secret for Marketo Rest.");
      }  
      if (!isValidHttpUrl(jQuery.trim(jQuery("#marketo-identity-url-input").val()))){
        errorMsgs.push("Please enter valid identity url for Marketo Rest.");
      } 
      if (!isValidHttpUrl(jQuery.trim(jQuery("#marketo-endpoint-url-input").val()))){
        errorMsgs.push("Please enter valid endpoint url for Marketo Rest.");
      }

      let username = jQuery.trim(jQuery("#marketo-rest-username-input").val());
      let password = jQuery.trim(jQuery("#marketo-rest-password-input").val())
      if (username == "" && password != ""){
        errorMsgs.push("Please enter Username for Marketo Rest.");
      } 
      if (password == "" && username != ""){
        errorMsgs.push("Please enter Password for Marketo Rest.");
      }
    }
    if (errorMsgs.length > 0) {
      setServerErrorMessage(errorMsgs);
      return false;
    } else {
      setServerErrorMessage([]);
      return true;
    }
  }

  const updatePreference = (e) => {
    let el = jQuery(e.target);
    let userGroupId = el.attr('data-group');
    let preference = el.attr('data-pref');
    let checked = el.is(':checked');

    let updatedPreferenceObj = updateDepartmentPreference(userGroupId,preference, checked);
    let payload = {};
    if(updatedPreferenceObj){
        payload[userGroupId] = [updatedPreferenceObj];//update only single preference at a time
    }

    postAxiosResponse(APIUrls.CUSTOMER_DEPARTMENT_PREFERENCE_ALL, payload)
    .then((res) => {
      if (res.data.code === 200) {
        setDeptPreference(res.data.data);
        setSuccessMessage(`Preference updated successfully.`);
      }else{
        updateDepartmentPreference(userGroupId,preference, !checked);
      }
    }).catch((err) => {
      updateDepartmentPreference(userGroupId,preference, !checked);
      handleError(err);
    })
  }

  const updateDepartmentPreference = (departmentId, preference, checked) => {
      let preferenceObject;
      let localDeptPreference = JSON.parse(JSON.stringify(deptPreference));
      Object.entries(localDeptPreference).map(([deptId, prefs]) => {
        if (deptId === departmentId) {
          let pref = prefs.find(pref => {
            return pref.preference === preference
          })
          if(pref){
              pref.status = ""+checked;//converting to string
              preferenceObject = pref;
          }
        }
      })
      setDeptPreference(localDeptPreference);
      return preferenceObject;
  }

  const getUser = () => {    
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.FULL_USER + `?_=${dateTimestamp}`
		).then(res => {
      if (res.data.code === 200) {
			  let user = transformBlankToNull(res.data.data);
        setUser(user)
      }
		})
  }

  const getAllDepartments = () => {
    setPendingDeptSettings(true);
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.DEPARTMENT_INCLUDE_SYSTEM_IF_POPULATED + `?_=${dateTimestamp}`
      ).then((res) => {
        if (res.data.code === 200) {
          setDepartments(res.data.data)
        }
      }).catch((err) => {
        handleError(err);
    });
  }

  const getAllDepartmentSystemUserCredential = (service) => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.CUSTOMER_EXTERNAL_SYSTEM_USER_CREDENTIALS_ALL_DEPARTMENTS(service) + `?_=${dateTimestamp}`
      ).then((res) => {
        if (res.data.code === 200) {
          setSystemUserCredentialsAllDepartments(res.data.data);
        }
      }).catch((err) => {
        handleError(err);
    });
  }

  const getIntegrationusers = () => {
    setPendingPermission(true);
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.CUSTOMER_INTEGRATION_USERS + `?_=${dateTimestamp}`
    ).then((res) => {
      setPendingPermission(false);
      if (res.data.code === 200) {
        let integrationUsers = transformBlankToNull(res.data.data);
        setIntegrationUsers(integrationUsers);
      }
    }).catch((err) => {
      handleError(err);
    });
  }

  const getSystemUserCredential = (userGroupId, setting) => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.CUSTOMER_EXTERNAL_SYSTEM_USER_CREDENTIALS(Constants.MARKETOREST) + `?userGroupId=${userGroupId}&_=${dateTimestamp}`
      ).then((res) => {
        if (res.data.code === 200) {
          var credentialsSet = transformBlankToNull(res.data.data.body)
          if (setting){
            if (credentialsSet?.id === null) {
              setting.isCredentialFound = false
            } else {
              setting.isCredentialFound = true
            }
          }
          setSystemUserCredentialData(credentialsSet);
        }
      }).catch((err) => {
        handleError(err);
    });
  }

  const getDepartmentPreference = () => {
    setPendingDeptSettings(true);
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.CUSTOMER_DEPARTMENT_PREFERENCE_ALL + `?_=${dateTimestamp}`
      ).then((res) => {
        if (res.data.code === 200) {
          setDeptPreference(res.data.data)
        }
      }).catch((err) => {
        handleError(err);
    });
  }

  const getPreference = () => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.CUSTOMER_ORG_PREFERENCE + `?preference=ENABLE_MARKETOREST_INTEGRATION&_=${dateTimestamp}`
      ).then((res) => {
        if (res.data.code === 200) {
          setPreference(res.data.data);
        }
      }).catch((err) => {
        handleError(err);
    });
  }

  const getSharedCredentials = () => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS_SHARED(Constants.MARKETOREST) + `?_=${dateTimestamp}`
      ).then((res) => {
        if (res.data.code === 200) {
          setSharedCredentials(res.data.data.body);
        }
      }).catch((err) => {
        handleError(err);
    });
  }

  const getCredential = () => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(Constants.MARKETOREST) + `?_=${dateTimestamp}`
    ).then (res => {
      if (res.data.code === 200) {
        var credentialsSet = transformBlankToNull(res.data.data.body)
        setCredentialData(credentialsSet)
      }
    }).catch(err => {
      handleError(err);
    });   
  };

  const clopseExpandAccordion = (accordion) => {
    if (accordion.hasClass("open")) {
      accordion.removeClass("open")
    } else {
      accordion.addClass("open")
    }
  }

  const close = () => {
    navigate("/settings")
  }

  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
      .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING });
  };

    $(document).ready(function(){
     $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
     $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
    })

  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Marketo Rest Integration', url:''},
   ];
  return (
    <>
      <div className={isValidating ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines strokeColor="#0096FF" strokeWidth="5" width="196" visible={true} />
        </div>
      </div> 
    {(successMessage!==undefined && successMessage !== Constants.BLANK)?<SuccessMessage message={successMessage}/>:Constants.BLANK}
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
             <div className="project-setting-page">
                <div className="project-heading userprofile-heading">
                  <BackToSetting />
                    <h3 className="flex">{translate("settings.marketo_rest_integration")}</h3>
                    <span>{translate("settings.marketo_multilingual")}</span>
                 </div>
                <div className="white-bg"> 
                <div className="integration-tab-content marketo-integration-accordion">
                {roleArray.includes ("ROLE_CUSTOMER")  ? (
                    <div id="permission-accordion" className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>{translate("settings.permissions_marketo")}</strong>
                        </div>
                        <div className="right" onClick={() => clopseExpandAccordion(jQuery("#permission-accordion"))}>
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                       <p>Manage who has permission to create Marketo Rest integration projects in OPAL-Marketing.
                         Users can set up their Marketo Rest credentials in the "Integration" subtab of the My Account page.</p>
                          <UserPermissionsSettingMemo 
                          settingType = {Constants.MARKETOREST}
                          accessName = "Access To Marketo Rest"
                          integrationUsers={integrationUsers}
                          pendingPermission={pendingPermission}
                          getUser={getUser}
                          setPermissionStatus={setPermissionStatus}
                        />
                      </div>
                    </div>
                ) : null}
                {roleArray.includes ("ROLE_CUSTOMER")  ? (
                    <div id="department-accordion" className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Department Settings</strong>
                        </div>
                        <div className="right" onClick={() => clopseExpandAccordion(jQuery("#department-accordion"))}>
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                       <div className="datatable-block custom_pagination">
                        <DataTable 
                            columns={deptSettingsColumns}
                            data={settings} 
                            highlightOnHover
                            responsive
                            striped
                            selectableRowsHighlight={true}
                            defaultSortFieldId={1}
                            theme={theme}
                            progressPending={pendingDeptSettings}
                            onSort={handleSort}
                          />
                        </div>
                      </div>
                    </div>
                    ) : null}

                    {user?.permissions[Constants.MARKETOREST_ACCESS] === true &&
                    <div id="credential-accordion" className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Marketo Rest API Settings</strong>
                        </div>
                        <div className="right" onClick={() => clopseExpandAccordion(jQuery("#credential-accordion"))}>
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      {showCustomerCred && 
                      <div className="integration-accordion-content">
                         <p className="f14-para">Enter your Marketo Rest API information here in order to sync financial data back to Marketo.
                           To find this information in Marketo, go to the "Admin" section and click on "REST API".
                            You must be have admin privileges on your Marketo account in order to access this info</p>
                          
                          <MarketoRestCredentialMemo 
                            authCodeMode = {authCodeMode}
                            credentialData = {credentialData} 
                            errorMessages = {serverErrorMessage}
                            isValidating = {isValidating}
                            successMessage = {successMessage}
                            closePopup = {hideEditModel}
                          />
                          <div className="flex flex-end mar-top20">
                            <button id="validate-credential" className="blue-btn active" onClick={() => submitCredential(false)}>Validate</button>
                          </div>
                      </div>}
                    </div>
                    }
                  </div> 
                </div>
             </div>
          </div>
        </section>
      </div>
      
          <div className="lightbox-panel sm-lg-lightbox-panel">
              <div className="inner-lightbox-panel pb-0">
              <div className="modal-header flex padd-lr">
                <strong>Department : {department.name}</strong>
                <button className="close" aria-label="close popup" onClick={hideEditModel}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path><path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path></svg>
                </button>
              </div>
              <div className="lightbox-content padd-22">
                 <div className="flex">
                  <div className="leftBlock">
                     <p>Please log in to your Marketo account to access your marketing assets through OPAL-Marketing.</p>
                     <p>Once you have logged in, you will be able to see all of your Marketo assets and automate their translation.</p>
                     <p><a href="#">Learn More about Marketo Integration</a></p>
                    {authCodeMode &&
                      <><span className="error">
                        Marketo requires that you register this device before continuing. 
                        Please check your email for a device authentication request from Marketo within the next few minutes.
                      </span><br /><br />              
                      On the email from Marketo, you will find an Authorization Code. 
                      Please type or copy and paste the code to the box on this page and click the Save button.<br /><br /> 
                    </>
                    }
                  </div>
                  <div className="rightBlock">
                    <div className="flex wrap-dropdown flex-column mb-0">
                      <MarketoRestCredentialMemo 
                        authCodeMode = {authCodeMode}
                        credentialData = {systemUserCredentialData} 
                        errorMessages = {serverErrorMessage}
                        isValidating = {isValidating}
                        successMessage = {successMessage}
                        closePopup = {hideEditModel}
                      />
                    </div>
                  </div>
                  
                 </div>
              </div>	
              <div className="modal-footer modal-footer-border flex px-22">
                {!permissionStatus && <p className="textDanger">{Constants.PERMISSION}</p>}
                    <button className="btn btn-bold" onClick={hideEditModel}>Cancel</button>
                    {permissionStatus &&  <button id="save-credential" className="btn btn-bold active" onClick={() => submitCredential(true)}>Save</button>}
                </div>
              </div>		
        </div>
        <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
            <div>
            <button className="btn-default" onClick={() => close()}>Close</button>
            </div>
        </div>
     </div>
    </div>
    </>
  );
}
